export default function MeshesIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="6.5" stroke="currentColor" strokeWidth="1.7" />
      <ellipse cx="10" cy="10" rx="6.5" ry="2.6" stroke="currentColor" strokeWidth="1.2" />
      <ellipse cx="10" cy="10" rx="2.8" ry="6.5" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}
